import { render, staticRenderFns } from "./LookForCandidates.vue?vue&type=template&id=4ec8851b&scoped=true&"
import script from "./LookForCandidates.vue?vue&type=script&lang=js&"
export * from "./LookForCandidates.vue?vue&type=script&lang=js&"
import style0 from "./LookForCandidates.vue?vue&type=style&index=0&id=4ec8851b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8851b",
  null
  
)

export default component.exports